import { DevtoolsShell, createActionPlugin, reactPanelPlugin, fillPanel } from '@houzy/devtools/react';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';

import { router } from '../../router';
import { config } from '../config';
import { queryClient } from '../queryClient';

const API_BASE_URL = (config.apiUrl as string | undefined) ?? '/api';

async function invalidatePartnerCockpitTranslations(): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/translations/invalidate-cache-partner-cockpit`, {
        method: 'GET',
    });
    if (!response.ok) {
        throw new Error(`Request failed (${response.status})`);
    }
}

export function HouzyDevtools(): React.JSX.Element {
    return (
        <DevtoolsShell
            plugins={[
                reactPanelPlugin('React Query', <ReactQueryDevtoolsPanel client={queryClient} style={fillPanel} />, {
                    defaultOpen: true,
                }),
                reactPanelPlugin('Router', <TanStackRouterDevtoolsPanel router={router} style={fillPanel} />),
                createActionPlugin({
                    title: 'Translations',
                    description: 'Re-fetch and cache the partner-cockpit translations on the backend.',
                    buttonLabel: 'Invalidate translations cache',
                    run: invalidatePartnerCockpitTranslations,
                }),
            ]}
        />
    );
}
